import { ref, reactive, watch } from 'vue'
import Ajax from "@utils/ajax"
import axios from "axios"

export const ImageList = ref([])
export const selectedImage = ref({})

class Uploader {
    state = reactive({
        tabs: {
            library: 'Image library',
            upload: 'Upload image',
        },
        tab: 'library',
        loading: false,
        open: false,
        dragover: false,
        uploading: false,
        activeUploader: '',
        multiple: false,
        crop: false,
        ratio: 16 / 9,
    })

    open = async (tab = null, activeUploader = this.state.activeUploader, multiple = this.state.multiple, crop = false, ratio = 16 / 2) => {
        if (tab) this.state.tab = tab

        this.state.multiple = multiple
        this.state.activeUploader = activeUploader
        this.state.open = true
        this.state.crop = crop
        this.state.ratio = ratio

        console.log("STATE", this.state)


        if (typeof selectedImage.value[this.state.activeUploader] == 'undefined') {
            if (this.state.multiple) {
                selectedImage.value[this.state.activeUploader] = []
            } else {
                selectedImage.value[this.state.activeUploader] = ''
            }
        }

        await this.fetchImages()
    }

    close = () => {
        this.state.activeUploader = ''
        this.state.multiple = false
        this.state.open = false
    }

    fetchImages = async () => {
        const response = await Ajax.get('admin_get_media')

        ImageList.value = response.data
    }

    selectImage = (url = null, shouldClose = false) => {
        if (typeof selectedImage.value[this.state.activeUploader] == 'undefined') {
            if (this.state.multiple) {
                selectedImage.value[this.state.activeUploader] = []
            } else {
                selectedImage.value[this.state.activeUploader] = ''
            }
        }

        let imageExist = this.state.multiple ? selectedImage.value[this.state.activeUploader].includes(url) : selectedImage.value[this.state.activeUploader] == url

        if (imageExist) {
            if (this.state.multiple) {
                let index = selectedImage.value[this.state.activeUploader].indexOf(url)
                selectedImage.value[this.state.activeUploader].splice(index, 1)
            } else {
                selectedImage.value[this.state.activeUploader] = ''
            }
            // let index = selectedImage.value[this.state.activeUploader].indexOf(url)
            // selectedImage.value[this.state.activeUploader].splice(index, 1)
        } else if (!imageExist) {
            if (this.state.multiple) {
                selectedImage.value[this.state.activeUploader].push(url)
            } else {
                selectedImage.value[this.state.activeUploader] = url
            }
        }
        else {
            // selectedImage.value[this.state.activeUploader].push(url)
            console.warn('Prebook: something is wrong with image uploader')
        }


        if (shouldClose) {
            this.close()
        }

        // Trigger event

    }

    changeTab = (tab) => {
        this.state.tab = tab
    }

    /**
     * Extract files from event
     * 
     * @param {*} event 
     */
    extractUploader = (event) => {
        if (event.target.files) {
            event.target.files.forEach(async (f, index) => {
                await this.upload(event.target.files[index])
            })
        }
    }

    selectFile = (event) => {
        this.extractUploader(event)
    }


    upload = async (base64Image) => {
        this.open('upload')
        const formData = new FormData()
        formData.append('image', base64Image)

        this.state.uploading = true

        // Upload image as file, use axios
        const response = await axios.post('/wp-admin/admin-ajax.php?action=prebook_admin_upload_media&nonce=' + prebook_admin.nonce,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        console.log("UPLOAD", response.data)


        this.state.uploading = false

        if (response.data.success) {
            await this.fetchImages()
            this.state.tab = 'library'

            Log('select', response.data.data.url)
            this.selectImage(response.data.data.url)

            return response.data.data.url
        } else {
            window.alert(response.data.data)

            return false
        }
        // Log('UPLOAD', response.data.data.url)

        // this.selectImage(response.data.data.url)
    }

    onDrop = (event, outer = true) => {
        this.state.dragover = false
        if (!outer) return
        this.extractUploader(event)
    }

    dragover = (e) => {
        // console.log('dragover')

        // if (props.modelValue) return
        this.state.dragover = true
    }

    dragleave = (e) => {
        // console.log('dragleave')

        this.state.dragover = false
    }
}


export const mediaUploader = new Uploader()

window.addEventListener('keydown', (e) => {
    // close modal if click keyboard esc
    if (e.key === 'Escape') mediaUploader.close()
})